export default "__VITE_ASSET__CLu_GGud__"